import './AdminDashboard.css';
import '../../App.css';
import { useEffect, useState } from 'react';
import { Table } from 'antd';
import 'antd/dist/antd.css';
import React from 'react';
import rightdoctor from "../../media/image.jpg"
import AdminSidebar from "./AdminSidebar";
import './Sidebar.css'
import { useStateValue } from "../../Component/StateProviders";
import { notification } from "antd";
import toast from 'react-hot-toast';
import Loader from "../../Component/Loader";


function AdminDashboard() {




    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        showSizeChanger: true,
    });

    const handleTableChange = (pagination) => {
        setPagination(pagination);
    };
    //     ######################### Notification Section ###########################

    const [anchorEl, setAnchorEl] = useState(null);


    // const [AllMsg,setAllMsg] = useState([])
    const [GroupName, setGroupName] = useState('')
    // const [unreadcount,setunreadcount] = useState("")


    const [chatSocket, setChatSocket] = useState(null);
    const [webSocketInitialized, setWebSocketInitialized] = useState(false);

    useEffect(() => {

        if (!webSocketInitialized) {

            const socket = new WebSocket(
                window.WEBSOC + 'ws/AdminDashboard/'
            );
            socket.onopen = () => {
                console.log("WebSocket connection opened");
                setWebSocketInitialized(true);

            };
            socket.onmessage = function (e) {
                let received_data_as_object = e['data'];
                // console.log(received_data_as_object)

                if (received_data_as_object.split("_")[0] === "Reload") {
                    if (AppointmentOption[0]) {
                        upcoming_booking()
                    }
                    else if (AppointmentOption[1]) {
                        today_booking()
                    }
                    else if (AppointmentOption[2]) {
                        previous_booking()
                    }
                    else if (AppointmentOption[3]) {
                        all_trash_booking()
                    }
                }
                //   const data = JSON.parse(e.data);
                // setChatLog((prevChatLog) => prevChatLog + e.data + '\n');
            };

            socket.onclose = function (e) {
                console.error('Chat socket closed unexpectedly');
                setWebSocketInitialized(false);

            };
            setChatSocket(socket);
            // return () => {
            //     socket.close();
            // };

        }
    }, [GroupName])





    const [loaderon, setloaderon] = useState({});
    const [loaderonpayment, setloaderonpayment] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const handlePageChange = (page) => {
        setCurrentPage(page - 1);
        console.log('Current page:', page);
    };



    const [entriesPerPage, setEntriesPerPage] = useState(10);

    const handleEntriesPerPageChange = (current, size) => {
        setEntriesPerPage(size);
        console.log('Entries per page:', size);
    };

    const findBookingIndex = (id) => {
        const index = AppointmentData.findIndex(booking => booking.BookingId === id);
        return index;
    };

    function Pending_Payment(Paymentindex, BookingId) {
        var Url = window.API_PREFIX + 'admin/Paybydoctor'
        var BookingIndex = findBookingIndex(BookingId)
        setloaderonpayment({ ...loaderonpayment, [Paymentindex]: true });
        fetch(Url, {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify({
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId'],
                    PatientId: AppointmentData[BookingIndex]['PatientId']
                }),
        }).then(resp => resp.json()).then(data => {
            setloaderonpayment({ ...loaderonpayment, [Paymentindex]: false });
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp[BookingIndex]['BookingStatus'] = 2
                setAppointmentData([...tmp])
            }
        })
    }


    function Delete_Appointment(Requestindex, BookingId) {
        var Url = window.API_PREFIX + 'booking/delete_booking'
        // dispatch({
        //     type: 'StartLoad'
        // })
        var BookingIndex = findBookingIndex(BookingId)

        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            // dispatch({
            //     type: 'StopLoad'
            // })
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp.splice(BookingIndex, 1)
                setAppointmentData([...tmp])
            }
        })


    }


    function RestoreRequest(Requestindex, BookingId) {
        var Url = window.API_PREFIX + 'booking/restore_trash_booking'
        // dispatch({
        //     type: 'StartLoad'
        // })
        var BookingIndex = findBookingIndex(BookingId)

        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            // dispatch({
            //     type: 'StopLoad'
            // })
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp.splice(BookingIndex, 1)
                setAppointmentData([...tmp])
            }
        })


    }

    function TrashDelete(Requestindex, BookingId) {
        var Url = window.API_PREFIX + 'booking/trash_booking'
        var BookingIndex = findBookingIndex(BookingId)

        // dispatch({
        //     type: 'StartLoad'
        // })
        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            // dispatch({
            //     type: 'StopLoad'
            // })
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp.splice(BookingIndex, 1)
                setAppointmentData([...tmp])
            }
        })


    }

    function AcceptRequest(Requestindex, BookingId) {
        var Url = window.API_PREFIX + 'booking/approve_booking'
        var BookingIndex = findBookingIndex(BookingId)
        setloaderon({ ...loaderon, [Requestindex]: true });
        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId']


                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            setloaderon({ ...loaderon, [Requestindex]: false });
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp[BookingIndex]['BookingStatus'] = 2
                setAppointmentData([...tmp])
            }
        })


    }





    function RejectRequest(Requestindex, BookingId) {


        var Url = window.API_PREFIX + 'booking/reject_booking'
        setloaderon({ ...loaderon, [Requestindex]: true });
        var BookingIndex = findBookingIndex(BookingId)

        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId'],




                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            setloaderon({ ...loaderon, [Requestindex]: false });
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp[BookingIndex]['BookingStatus'] = -1
                setAppointmentData([...tmp])
            }
        })

    }



    function DeleteRequest(Requestindex, BookingId) {
        var BookingIndex = findBookingIndex(BookingId)

        var Url = window.API_PREFIX + 'admin/delete_booking'
        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(
                {
                    Token: localStorage.getItem('DToken'),
                    Id: AppointmentData[BookingIndex]['BookingId'],




                }
            ),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            if (data['status'] === "1") {
                var tmp = AppointmentData
                tmp[BookingIndex]['BookingStatus'] = -1
                setAppointmentData([...tmp])
            }
        })

    }
    // function AcceptRequest(Requestindex) {
    //     var tmp = AppointmentData
    //     tmp[Requestindex]['BookingStatus'] = 1
    //     setAppointmentData([...tmp])
    // }

    // function RejectRequest(Requestindex) {
    //     var tmp = AppointmentData
    //     tmp[Requestindex]['BookingStatus'] = -1
    //     setAppointmentData([...tmp])
    // }



    const columns = [
        {
            title: 'Client Name',

            dataIndex: 'PatientName',
            key: 'name',
            render: (text, record) => <>
                <div className='mitwank_dashboard_table_image_name_division'>
                    <img className='mitwank_dashboard_table_image' src={record['ProfilePic']} style={{ height: '2.5rem', width: '2.5rem' }} />
                    <div className='mitwank_dashboard_table_name_id_division'>
                        <div className='mitwank_dashboard_table_patient_name'>{text}</div>
                        <div className='mitwank_dashboard_table_patient_id'>#pt{record['PatientId']}</div>
                    </div>
                </div>
            </>

        },
        {
            title: 'Appt Date',
            dataIndex: 'Date',
            key: 'date',
            render: (text, record) => <>
                <div className='mitwank_dashboard_time_date_div'>
                    <div className='mitwank_dashboard_table_appt_date'>{text}</div>
                    <div className='mitwank_dashboard_table_appt_time'>{record['Time']}</div>
                </div>
            </>
        },
        {
            title: 'Package',
            dataIndex: 'Purpose',
            key: 'package',
            render: (text, record, index) => <>
                <div className='mitwank_dashboard_table_appt_date'>{text}</div>

            </>
        },
        {
            title: ' Amount',
            dataIndex: 'Amount',
            key: 'paidamount',
        },
        {

            title: 'Option',
            key: 'tags',
            dataIndex: 'BookingStatus',
            render: (text, record, index) => (

                <>
                    {text === 0 ?
                        <div className='mitwank_dashboard_tabel_view_accept_cancel'>


                            {
                                loaderon[index] ? <Loader /> : <button className='btn mitwank_dashboard_tabel_accept_btn'
                                    onClick={() => {

                                        AcceptRequest(index, record.BookingId)
                                    }}
                                >Accept</button>
                            }



                            {
                                loaderon[index] ? <Loader /> : <button className='btn mitwank_dashboard_tabel_cancel_btn'

                                    onClick={() => {

                                        RejectRequest(index, record.BookingId)
                                    }}
                                >Reject</button>
                            }




                        </div>
                        : text === 1 ?
                            <div className='mitwank_dashboard_tabel_view_accept_cancel'>
                                <div><button className='btn mitwank_dashboard_tabel_accept_btn' disabled>Accepted</button></div>
                            </div>
                            : text === 2 ?
                                <div className='mitwank_dashboard_tabel_view_accept_cancel'>
                                    <div><button className='btn mitwank_dashboard_tabel_accept_btn' disabled>Accepted</button></div>
                                </div>
                                :
                                <div className='mitwank_dashboard_tabel_view_accept_cancel'>
                                    <div><button className='btn mitwank_dashboard_tabel_cancel_btn'
                                        disabled
                                    >Rejected</button></div>
                                </div>
                    }

                </>
            ),
        },
        {

            title: 'Payment Status',
            key: 'tags',
            dataIndex: 'Ispaid',
            render: (text, record, index) => (
                <>
                    <div className='mitwank_dashboard_tabel_view_accept_cancel'>
                        {record['BookingStatus'] === 1 || record['BookingStatus'] === 2 ? (
                                <div>
                                    <button className='btn mitwank_dashboard_tabel_accept_btn' disabled>
                                        Completed</button>
                                </div>
                            ) : record['BookingStatus'] === 0 ? (
                                    <div>
                                        <button className='btn mitwank_dashboard_tabel_view_btn' disabled>Pending Request</button>
                                    </div>
                            ) : (
                                    <div>
                                        <button className='btn mitwank_dashboard_tabel_cancel_btn' disabled>N/A</button>
                                    </div>
                            )}
                    </div>
                </>
            ),
        },
        {
            title: 'Actions',
            dataIndex: 'Actions',
            key: 'Actions',
            render: (text, record, index) => (

                <>
                    <i class="fa-solid fa-trash-can" style={{ color: '#e11f28' }}
                        onClick={() => {
                            // var INDEX = currentPage * entriesPerPage + index

                            TrashDelete(index, record.BookingId)
                        }}

                    ></i>

                </>
            ),

        },
    ];




    const trashColumns = [
        {
            title: 'Client Name',

            dataIndex: 'PatientName',
            key: 'name',
            render: (text, record) => <>
                <div className='mitwank_dashboard_table_image_name_division'>
                    <img className='mitwank_dashboard_table_image' src={record['ProfilePic']} style={{ height: '2.5rem', width: '2.5rem' }} />
                    <div className='mitwank_dashboard_table_name_id_division'>
                        <div className='mitwank_dashboard_table_patient_name'>{text}</div>
                        <div className='mitwank_dashboard_table_patient_id'>#pt{record['PatientId']}</div>
                    </div>
                </div>
            </>

        },
        {
            title: 'Appt Date',
            dataIndex: 'Date',
            key: 'date',
            render: (text, record) => <>
                <div className='mitwank_dashboard_time_date_div'>
                    <div className='mitwank_dashboard_table_appt_date'>{text}</div>
                    <div className='mitwank_dashboard_table_appt_time'>{record['Time']}</div>
                </div>
            </>
        },
        {
            title: 'Package',
            dataIndex: 'Purpose',
            key: 'package',
            render: (text, record) => <>
                <div className='mitwank_dashboard_table_appt_date'>{text}</div>

            </>
        },
        {
            title: ' Amount',
            dataIndex: 'Amount',
            key: 'paidamount',
        },
        {

            title: 'Option',
            key: 'tags',
            dataIndex: 'BookingStatus',
            render: (text, record, index) => (

                <>

                    <div><button className='btn mitwank_dashboard_tabel_cancel_btn'

                        onClick={() => {
                            var INDEX = currentPage * entriesPerPage + index

                            RestoreRequest(INDEX, record.BookingId)
                        }}
                    >Restore</button></div>
                </>
            ),
        },
        {
            title: 'Actions',
            dataIndex: 'Actions',
            key: 'Actions',
            render: (text, record, index) => (

                <>
                    <i class="fa-solid fa-trash-can" style={{ color: '#e11f28' }}
                        onClick={() => {
                            var INDEX = currentPage * entriesPerPage + index

                            Delete_Appointment(INDEX, record.BookingId)
                        }}

                    ></i>

                </>
            ),

        },
    ];



    function upcoming_booking() {
        var Url = window.API_PREFIX + 'admin/upcoming_booking'
        fetch(Url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            },
            // body: JSON.stringify({'Token':localStorage.getItem('DToken')}),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            // dispatch({
            //     type:'StopLoad'
            // })
            if (data['status'] === "1") {
                setAppointmentOption([true, false, false, false])

                setAppointmentData([...data["Booking"]])
            }
        })
    }

    function today_booking() {
        var Url = window.API_PREFIX + 'admin/Today_booking'
        fetch(Url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            },
            // body: JSON.stringify({'Token':localStorage.getItem('DToken')}),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            if (data['status'] === "1") {
                setAppointmentOption([false, true, false, false])
                setAppointmentData([...data["Booking"]])
            }
        })
    }


    function previous_booking() {
        var Url = window.API_PREFIX + 'admin/Previous_booking'
        fetch(Url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            },
            // body: JSON.stringify({'Token':localStorage.getItem('DToken')}),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            if (data['status'] === "1") {
                setAppointmentOption([false, false, true, false])

                setAppointmentData([...data["Booking"]])
            }
        })
    }

    function all_trash_booking() {
        var Url = window.API_PREFIX + 'admin/all_trash_bookings'
        fetch(Url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            },
            // body: JSON.stringify({'Token':localStorage.getItem('DToken')}),
        }).then(resp => resp.json()).then(data => {
            console.log(data)
            if (data['status'] === "1") {
                setAppointmentOption([false, false, false, true])

                setAppointmentData([...data["Booking"]])
            }
        })
    }
    const [AppointmentData, setAppointmentData] = useState([])
    const [AppointmentOption, setAppointmentOption] = useState([true, false, false, false])

    useEffect(() => {
        upcoming_booking()
    }, [])





    // responsive table data start






    // responsive table data end

    return (
        <>
            <div className="container-fuild mx-2" >
                <div className='mitwank_dashboard_main_diviison'>
                    <div className='mitwank_dashboard_patient_appointment_table_main_division'>
                        {/* <p className='mitwank_dashboard_patientappoinment_name'>Client Appoinments</p> */}
                        <div className='mitwank_dashboard_upcoming_today_btn_divsion'>
                            <div className='mitwank_dashboard_today_btn_divsion'>
                                <button type="button" class={AppointmentOption[0] ? "btn mitwank_dashboard_upcoming_btn_active" : 'btn mitwank_dashboard_upcoming_btn'}
                                    onClick={() => {

                                        upcoming_booking()
                                    }}
                                >Upcoming</button>
                            </div>
                            <div className='mitwank_dashboard_today_btn_divsion'>
                                <button type="button" class={AppointmentOption[1] ? "btn mitwank_dashboard_upcoming_btn_active" : 'btn mitwank_dashboard_upcoming_btn'}
                                    onClick={() => {
                                        today_booking()

                                    }}
                                >Today</button>
                            </div>
                            <div className='mitwank_dashboard_today_btn_divsion'>
                                <button type="button" class={AppointmentOption[2] ? "btn mitwank_dashboard_upcoming_btn_active" : 'btn mitwank_dashboard_upcoming_btn'}
                                    onClick={() => {
                                        previous_booking()
                                    }}>Previous</button>
                            </div>

                            <div className='mitwank_dashboard_today_btn_divsion'>
                                <button type="button" class={AppointmentOption[3] ? "btn mitwank_dashboard_upcoming_btn_active" : 'btn mitwank_dashboard_upcoming_btn'}
                                    onClick={() => {


                                        all_trash_booking()
                                    }}>Trash</button>
                            </div>


                        </div>
                        <div className='mitwank_dashboard_patient_appointment_table_division'>
                            <Table columns={AppointmentOption[3] ? trashColumns : columns} dataSource={AppointmentData}
                                // pagination={{
                                //     current: currentPage + 1,
                                //     onChange: handlePageChange,
                                //     pageSize: entriesPerPage,
                                //     onShowSizeChange: handleEntriesPerPageChange,
                                // }}
                                pagination={pagination}
                                onChange={handleTableChange}
                            />

                            {/* <Button type="primary" onClick={openNotification}>
                                        Open the notification box
                                    </Button> */}

                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}
export default AdminDashboard;